<template>
  <section class="w3l-contact-1 w3hny-form-btm py-5" id="contact">
    <div class="contacts-9 py-lg-5 py-md-4">
      <div class="container">
        <div class="header-sec text-center mb-5">
          <br/>
          <h1 class="title-w3l">
            Create an account
          </h1>
        </div>
        <div class="contactct-fm map-content-9">
          <form class="pt-lg-4" onsubmit="return false;">
            <label for="firstName">First Name</label>
            <input type="text" class="form-control" id="firstName" v-model="firstName"/><br/>

            <label for="email">Email</label>
            <input type="email" class="form-control" id="email" v-model="email"/><br/>

            <label for="password">Password</label>
            <input type="password" class="form-control" id="password" v-model="password"/><br/>

            <label for="referral">Referrer (Optional)</label>
            <input type="text" class="form-control" id="referral" v-model="referral"/><br/>

            <div class="text-lg-center">
              <button type="button" class="btn btn-primary btn-style mt-lg-5 mt-4" v-on:click="register">{{
                  working ? "Signing Up..." : "Sign Up"
                }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import Log from "../../Common/Client/Log";
import Info from "../../Common/Client/Info";
import Notification from "../../Common/Client/Notification";
import Globals from "../global";
import type {NuxtApp} from "#app";
import {onMounted} from "@vue/runtime-core";

const headers = useRequestHeaders(['cookie'])
const token = useCookie("TOKEN", {maxAge: Globals.ONE_YEAR, path: "/", sameSite: "lax"});
const route = useRoute();
const working = ref(false);
const email = ref("");
const password = ref("");
const referral = ref("");
const firstName = ref("");

function log(message: string, isInfo: boolean = true) {
  Log.log(message, route.path, isInfo, headers);
}

const {
  data,
} = await useAsyncData(async function (ctx?: NuxtApp | undefined): Promise<unknown> {
  if (token.value != null)
    ctx?.runWithContext(async () => await navigateTo(`/dashboard`));
  return {};
});

useHead({
  //@ts-ignore
  title: `ForumLeadsFinder – Create an account`,
  meta: [
    {
      name: "description",
      //@ts-ignore
      content: `ForumLeadsFinder - Join us. Create an account to try out our lead generation system free of charge for 7 days. No credit card needed.`
    }
  ]
});

onMounted(() => {
  if (localStorage.getItem("viref")) {
    //@ts-ignore
    referral.value = localStorage.getItem("viref");
  }
});

async function register() {
  try {
    working.value = true;
    log("User clicked 'Sign Up'");
    log(`FirstName: ${firstName.value}`);
    log(`Email: ${email.value}`);
    log(`Check for valid data`);
    if (!firstName.value || !email.value || !password.value) {
      log(`Incomplete data`);
      Notification.error("Error", "Incomplete data");
      return {};
    }
    log(`Send details to server`);
    const signUpModel: any = {firstName: firstName.value, email: email.value, password: password.value, referral: referral.value};
    const response: Response = await $fetch.raw(`/api/users`, {
      body: signUpModel,
      method: "POST",
      headers,
      ignoreResponseError: true
    });
    const code: number = response.status;
    log(`code: ${code}`);
    if (code != 200) {
      log(`If invalid, show errors`);
      try {
        const errors = await response._data;
        errors.forEach((error: string) => {
          Notification.error("Error", error);
        });
      } catch (_) {
      }
      return;
    }
    log(`If successful, go to verify email page`);
    navigateTo("/verify-email");
  } catch (ex) {
    log("Error occurred while trying to sign user up", false);
    log(Info.prettifyIfPossible(ex), false);
    Log.reportError(headers);
  } finally {
    working.value = false;
  }
}
</script>

<style scoped></style>
